require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /~/core-js/modules/es6.array.species.js
// module id = Q/CP
// module chunks = 0